import MoreVertIcon from '@mui/icons-material/MoreVert'
import { Alert, Stack, TableCell, TableRow } from '@mui/material'
import { gray } from 'src/features/muikds/kdsColors'

const MAX_DISPLAYED_RECORDS = 50

type LimitAlertTableRowProps = {
  recordCount: number
  colSpan: number
}

export function LimitAlertTableRow({
  recordCount,
  colSpan,
}: LimitAlertTableRowProps) {
  // 上限未満の場合は何も表示しない
  if (recordCount < MAX_DISPLAYED_RECORDS) {
    return null
  }
  return (
    <TableRow>
      <TableCell colSpan={colSpan} sx={{ p: 0 }}>
        <Stack
          alignItems="center"
          gap={1}
          sx={{ maxWidth: 1080, position: 'sticky', left: 0, px: 2, py: 1 }}
        >
          <MoreVertIcon sx={{ color: gray[6] }} />
          <Alert severity="info" sx={{ width: '100%' }}>
            {`管理画面上には${MAX_DISPLAYED_RECORDS}件のみ表示されます。全てのデータを見るにはCSVをダウンロードしてください。`}
          </Alert>
        </Stack>
      </TableCell>
    </TableRow>
  )
}
